export const management = {
  routes: [
    {
      path: "/management/mail-log",
      component: () => import("../mail-log-view"),
    },
  ],
};
